<script>
export default {
  name: 'Reports',
  props: {
    category: { default: null, type: String }
  },
  data() {
    return {
      categories: [],
      reports: []
    }
  },
  computed: {
    categoryRows() {
      let rows = []
      for (let c = 0; c < this.categories.length; c++) {
        if (c % 3 == 0) {
          rows.push([])
        }
        rows.at(-1).push(this.categories[c])
      }
      return rows
    }
  },
  watch: {
    category: function() {
      this.loadReports()
    }
  },
  methods: {
    loadReports() {
      this.graphql(
        /* GraphQL */ `
          query lookupOptions_ReportCategoryLookup($categoryName: String) {
            allMetricsDashReportCategories(
              orderBy: CATEGORY_NAME_ASC
              filter: { categoryName: { equalTo: $categoryName } }
            ) {
              nodes {
                categoryName
                categoryDescription
                numReports
                metricsDashReportsByCategoryName(orderBy: REPORT_NAME_ASC) {
                  nodes {
                    reportName
                    reportDescription
                  }
                }
              }
            }
          }
        `,
        { categoryName: this.category }
      ).then(data => {
        this.categories = data.allMetricsDashReportCategories.nodes.filter(
          category =>
            category.numReports && category.categoryName != this.category
        )
        let thisCategory = data.allMetricsDashReportCategories.nodes.filter(
          category => category.categoryName == this.category
        )
        if (thisCategory.length) {
          this.reports = thisCategory[0].metricsDashReportsByCategoryName.nodes
        } else {
          this.reports = []
        }
      })
    },
    loadCategory(categoryName) {
      this.$router.push({
        name: 'ReportCategory',
        params: { category: categoryName }
      })
    },
    loadReport(reportItem) {
      this.$router.push({
        name: 'Report',
        params: { name: reportItem.reportName }
      })
    }
  },
  mounted() {
    this.loadReports()
  }
}
</script>

<template>
  <div class="p-4">
    <b-card-group
      deck
      class="w-100"
      v-for="(categoryRow, categoryRowIndex) in categoryRows"
      :key="categoryRowIndex"
    >
      <b-card
        :title="category.categoryName"
        class="m-2"
        v-for="(category, categroyIndex) in categoryRow"
        :key="categroyIndex"
        @click="loadCategory(category.categoryName)"
      >
        <b-card-text>{{ category.categoryDescription }}</b-card-text>
      </b-card>
    </b-card-group>
    <b-table
      striped
      hover
      :items="reports"
      v-if="reports.length"
      @row-clicked="loadReport"
    >
      <template v-slot:cell(reportDescription)="data">
        <span v-html="data.item.reportDescription"></span>
      </template>
    </b-table>
  </div>
</template>
